import { SVGProps } from 'react';

const External = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M3.25 18V8A2.75 2.75 0 0 1 6 5.25h6v1.5H6A1.25 1.25 0 0 0 4.75 8v10A1.25 1.25 0 0 0 6 19.25h10A1.25 1.25 0 0 0 17.25 18v-6h1.5v6A2.75 2.75 0 0 1 16 20.75H6A2.75 2.75 0 0 1 3.25 18m17.5-9h-1.5V5.81l-7.72 7.72-1.06-1.06 7.72-7.72H15v-1.5h5a.75.75 0 0 1 .75.75z"
    />
  </svg>
);

export default External;
